<template>
  <CustomDeleteDialog
    dialogTitle="حذف نوع محتوای درس"
    dialogId="object-skill-type-delete-confirmation-dialog"
    no-close-on-backdrop
    :isOkDisabled="isOkButtonDisabled"
    @ok="removeObjectSkillType"
  >
    <BCol cols="12">
      <p>
        آیا از حذف نوع محتوای
        <span class="font-weight-bolder">
          {{
            defaultObjectType && defaultObjectType.skillType
              ? objectSkillTypesEnum[defaultObjectType.skillType]
              : ""
          }}
        </span>
        اطمینان دارید؟
      </p>
    </BCol>
  </CustomDeleteDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    defaultObjectType: {
      type: Object,
    },
  },
  data() {
    return {
      isOkButtonDisabled: false,
      objectSkillTypesEnum: {
        1: "شنیداری (Listening)",
        2: "گفتاری (Speaking)",
        3: "خواندن (Reading)",
        4: "نوشتاری (Writing)",
      },
    };
  },
  methods: {
    async removeObjectSkillType() {
      try {
        this.isOkButtonDisabled = true;
        let _this = this;
        let deleteObjectSkillType = new DeleteObjectSkillType(_this);
        deleteObjectSkillType.setRequestParam({
          id: _this.defaultObjectType.objectSkillTypeId,
        });
        await deleteObjectSkillType.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "نوع محتوای درس با موفقیت حذف شد.",
              },
            });
            _this.$emit("refetch");
            _this.$bvModal.hide("object-skill-type-delete-confirmation-dialog");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  components: {
    BCol,
    CustomDeleteDialog,
  },
};
import CustomDeleteDialog from "@/views/components/Utils/Dialogs/CustomDeleteDialog.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { DeleteObjectSkillType } from "@/libs/Api/ObjectSkillType";
import { BCol } from "bootstrap-vue";
</script>
